// extracted by mini-css-extract-plugin
module.exports = {"singleSlider":"SingleHeroSlider_singleSlider__O_Uup","sliderContent":"SingleHeroSlider_sliderContent__WkNGj","imgWrapper":"SingleHeroSlider_imgWrapper__FZJkZ"};